function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { AelfIcon } from "../../icon/AelfIcon";
var AelfSVGComponent = function AelfSVGComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17.4 7.152v22.241a.4.4 0 0 1-.4.4h-2a.4.4 0 0 1-.4-.4V7.153l-6.237 6.238a.4.4 0 0 1-.565 0l-1.414-1.415a.4.4 0 0 1 0-.565l8.91-8.911a1 1 0 0 1 1.413 0l8.91 8.91a.4.4 0 0 1 0 .565l-1.414 1.414a.4.4 0 0 1-.566 0L17.4 7.152Z"
  }));
};
var componentName = 'UpArrowOutlined';
export var UpArrowOutlined = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(AelfIcon, _extends({
    component: AelfSVGComponent,
    ref: ref
  }, props));
});
UpArrowOutlined.displayName = componentName;